import { actionCreatorFactory } from "typescript-fsa";

export type ModalNames =
  | "project-support"
  | "companies/edit-basic-info"
  | "company_memberships/manager"
  | "company_values/selector"
  | "company_values/lp-announcement"
  | "posts/selector"
  | "companies/updates";

export interface Modal {
  name: ModalNames;
  id?: string;
}

const actionCreator = actionCreatorFactory("MODALS");

export const modalOpened = actionCreator<Modal>("OPENED");

export const modalClosed = actionCreator<Modal>("CLOSED");



// WEBPACK FOOTER //
// ./frontend/src/common/actions/Modal.ts